import { Modal, Empty } from "antd";
import { Flex } from "@chakra-ui/react";
import OutlineButton from "ui/components/Button/OutlineButton";
import { useLoading } from "ui/components/GlobalLoading/index";
import Historico from "./components/Historico";
import useHistoricoManutencao from "core/features/manutencao/hooks/useHistoricoManutencao";

interface ModalHistoricoManutencaoProps {
  isOpenModal: boolean;
  onClose: () => any;
  id: string | undefined;
}

export default function ModalHistoricoManutencao({
  id,
  isOpenModal,
  onClose,
}: ModalHistoricoManutencaoProps) {
  const { data, isFetching } = useHistoricoManutencao(id);

  useLoading(isFetching);

  return (
    <Modal
      visible={isOpenModal}
      onCancel={onClose}
      centered
      footer={
        <Flex flex={1} justifyContent="end">
          <OutlineButton onClick={onClose}>Fechar</OutlineButton>
        </Flex>
      }
    >
      <Historico logs={data ?? []} />
      {!data?.length && !isFetching ? (
        <Empty description="Sem dados de histórico para essa manutenção" />
      ) : null}
    </Modal>
  );
}
